interface Props {
    className?: string;
}

export function ClockIcon({ className }: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 25 24" fill="none">
            <path
                d="M12.5 1.5C6.70156 1.5 2 6.20156 2 12C2 17.7984 6.70156 22.5 12.5 22.5C18.2984 22.5 23 17.7984 23 12C23 6.20156 18.2984 1.5 12.5 1.5ZM12.5 20.7188C7.68594 20.7188 3.78125 16.8141 3.78125 12C3.78125 7.18594 7.68594 3.28125 12.5 3.28125C17.3141 3.28125 21.2188 7.18594 21.2188 12C21.2188 16.8141 17.3141 20.7188 12.5 20.7188Z"
                fill="currentColor"
            />
            <path
                d="M16.5945 14.9672L13.2523 12.5508V6.75C13.2523 6.64687 13.168 6.5625 13.0648 6.5625H11.9375C11.8344 6.5625 11.75 6.64687 11.75 6.75V13.2047C11.75 13.2656 11.7781 13.3219 11.8273 13.357L15.7039 16.1836C15.7883 16.2445 15.9055 16.2258 15.9664 16.1437L16.6367 15.2297C16.6976 15.1429 16.6789 15.0258 16.5945 14.9672Z"
                fill="currentColor"
            />
        </svg>
    );
}
